module.exports = __webpack_public_path__ + "static/media/uefaeuro2021.99bb7396.svg";